import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface MemberQueryDetailKeyFilter extends RequiredQueryKeyFilter {
  id: string;
}

interface MemberQueryListKeyFilter extends RequiredQueryKeyFilter {
  memberIdsKey?: string;
}

export const memberQueryKeys = createDefaultQueryKeysGenerator<
  MemberQueryListKeyFilter,
  MemberQueryDetailKeyFilter
>({
  keyDataType: 'members',
});
